export const isVisible = function(header, headers) {
    // find header
    let index = headers.findIndex(x => x.value === header.value);
    // add align string, if missing.
    if (!headers[index].align) headers[index].align = "";
    // find d-none
    let i = headers[index].align.match(/ ?d-none/g);
    // return true or false
    return !i;
};
export const toggleVisibility = function(selected_headers, all_headers) {
    // find header
    for (let [index, header] of all_headers.entries()) {
        // add align string if missing
        if (!header.align) header.align = "";
        // add d-none if header selected
        if (selected_headers.some(x => x.value === header.value)) {
            // concat d-none if necessary
            let i = header.align.match(/ ?d-none/g);
            if (!i) {
                let new_header = Object.assign(header, { align: (header.align += " d-none") });
                all_headers.splice(index, 1, new_header);
            }
        } else {
            let new_header = Object.assign(header, { align: header.align.replace(/ ?d-none/g, "") });
            all_headers.splice(index, 1, new_header);
        }
    }
};

export default {
    isVisible,
    toggleVisibility
};
